<template>
  <InteressesLayout>
    <template #cards>
      <v-flex xs3>
        <cbm-card :number-text="card.value" :title="card.text" :boolean-loader="loading" :is-currency="card.isCurrency" unset-percentage-colors simple-card />
      </v-flex>
    </template>
    <template v-slot:table="{ tableList }">
      <mf-loading :loader="['interesses-por-genero', 'primeiro-registro', 'last-update']" loader-type="table" :boolean-loader="loading">
        <v-data-table
          v-if="tableList === 'cupons'"
          :items="orderDescList(listaDeInteressesGenero, 'NUM_ITENS_TOTAL')"
          :items-per-page-options="rowsPerPageArray"
          :headers="headersCupons"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item['DES_CATEGORIA'] }}</td>
              <td class="text-right">{{ item['NUM_ITENS_TOTAL'] | localeString(item['NUM_ITENS_TOTAL'] % 1 ? 2 : 0) }}</td>
            </tr>
          </template>
        </v-data-table>

        <v-data-table
          v-else
          :items="orderDescList(listaDeInteressesGenero, 'VAL_FATURAMENTO_TOTAL')"
          :items-per-page-options="rowsPerPageArray"
          :headers="headersFaturamento"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item['DES_CATEGORIA'] }}</td>
              <td class="text-right">{{ item['VAL_FATURAMENTO_TOTAL'] | localeString(2) | currency }}</td>
            </tr>
          </template>
        </v-data-table>
      </mf-loading>
    </template>
  </InteressesLayout>
</template>

<script>
import InteressesLayout from '@/modules/clientes/interesses/layouts/Index.vue'
import CbmCard from '@/components/CbmCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { localeString } from '@/config/helpers.js'
import InteressesMixins from '@/modules/clientes/interesses/mixins/index'

export default {
  components: {
    InteressesLayout,
    CbmCard,
  },
  mixins: [InteressesMixins],
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState({
      listaDeInteressesGenero: (state) => state.clientes.listaInteressesGenero,
      stateTicketMedio: (state) => state.clientes.ticketMedio,
      stateFilters: (state) => state.filters,
    }),

    card() {
      return {
        text: 'Ticket médio',
        value: localeString(this.stateTicketMedio['VAL_TICKET_MEDIO'] || 0, 0),
        isCurrency: true,
        loader: ['primeiro-registro', 'ticket-medio', 'primeiro-registro', 'last-update'],
      }
    },
    headersCupons() {
      return [
        {
          text: 'Categorias',
          value: 'DES_CATEGORIA',
        },
        {
          text: 'Quantidade total',
          align: 'right',
          value: 'NUM_ITENS_TOTAL',
        },
      ]
    },
    headersFaturamento() {
      return [
        {
          text: 'Categorias',
          value: 'DES_CATEGORIA',
        },
        {
          text: 'Faturamento total',
          align: 'right',
          value: 'VAL_FATURAMENTO_TOTAL',
        },
      ]
    },
  },
  async mounted() {
    this.loading = true
    await this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getData)
      this.setFilters({ ...this.stateFilters, pessoa: 'J' })
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      listaInteressesPorGenero: 'interesses-por-genero',
      clientesTicketMedio: 'ticket-medio',
      setFilters: 'set-filters',
      empresaPrimeiroRegistro: 'primeiro-registro',
    }),
    async getData() {
      try {
        this.loading = true
        const filter = {
          unidades: this.stateFilters.unitsConfiguration,
          tipo_pessoa: 'J',
          categoria_cliente: this.stateFilters.cliente,
          fidelidade: this.stateFilters.fidelidade,
          segmentos: this.stateFilters.segmentos,
        }
        if (this.stateFilters.data?.[0].length > 0) {
          filter.date = this.stateFilters.data
        }
        await this.listaInteressesPorGenero(filter)
        await this.clientesTicketMedio(filter)
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
